import makeStyles from "@mui/styles/makeStyles";

import { theme } from "../../../App";
const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "70%",
    margin: "0 auto",
    alignItems: "center",
    color: "#333333",
  },
  surveyEndImage: {
    boxSizing: "border-box",
    width: 328,
    marginTop: 20,
    overflow: "hidden",
    "& > img": {
      width: "100%",
      minHeight: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      width: 374,
    },
  },
  welcomeHeader: {
    textAlign: "center",
    fontSize: 34,
    fontWeight: 300,
    margin: "24px 0",
    [theme.breakpoints.up("sm")]: {
      fontSize: 48,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 60,
    },
  },
  welcomeMessage: {
    fontSize: 16,
    fontColor: "#333333",
    textAlign: "center",
    marginBottom: 24,
    [theme.breakpoints.up("sm")]: {
      fontSize: 18,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 24,
    },
  },
  redirectBtn: {
    width: 180,
    minHeight: 40,
    border: 0,
    padding: 10,
    textAlign: "center",
    borderRadius: 5,
    fontWeight: 600,
    fontSize: 14,
    marginTop: 24,
    marginBottom: 24,
    backgroundColor: (props) => `${props.currentTheme.primaryColor}`,
    color: (props) => `${props.currentTheme.fontColor}`,
  },
}));

export default useStyles;
